"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var resource_1 = require("../../resource");
var comment = /** @class */ (function (_super) {
    tslib_1.__extends(comment, _super);
    function comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.route = '/bug/comment';
        return _this;
    }
    /**
     *
     * @param {number} id - id of comment to retrieve
     * @returns {Promise<Array<Comment>>} Comment which was requested.
     */
    comment.prototype.get = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({ url: this.route + "/" + id })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.comments[id]];
                }
            });
        });
    };
    /**
     *
     * @param {number} bugId The id of the bug to create the comment against
     * @param {Comment} comment The comment to be made
     */
    comment.prototype.create = function (bugId, comment) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({
                            url: "/bug/" + bugId + "/comment",
                            method: 'POST',
                            data: comment
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     *
     * @param {number} bugid - id of a bug to retrieve comments from.
     * @returns {Promise<Array<Comment>>} All comments from the selected bug.
     */
    comment.prototype.getAll = function (bugId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({ url: "/bug/" + bugId + "/comment" })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.bugs[bugId].comments];
                }
            });
        });
    };
    /**
     *
     * @param {string} term - A sub string to search tags.
     * @returns {Promise<Array<string>>} An Array of tags which contain the term sub string.
     */
    comment.prototype.searchTags = function (term) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({ url: this.route + "/tags/" + term })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     *
     * @param {number} bugid - id of a comment to update the tags for.
     * @returns {Promise<Array<string>>} Tags
     */
    comment.prototype.updateTags = function (id, update) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        update.comment_id = id;
                        return [4 /*yield*/, this.makeRequest({
                                url: this.route + "/" + id + "/tags",
                                method: 'PUT',
                                data: update
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return comment;
}(resource_1.resource));
exports.comment = comment;



//////////////////
// WEBPACK FOOTER
// ../node_modules/bzrest/lib/resources/bugs/comments/comments.js
// module id = 982
// module chunks = 0